import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MdSecurity } from 'react-icons/md';
import bgPattern1 from '../../assets/images/bg_pattern_1.png';
import bgPattern2 from '../../assets/images/bg_pattern_2.png';
import SecurityLogo from '../../assets/images/security_logo.png';
import { PG_PRIVACY_POLICY_URL, PG_TERMS_AND_CONDITIONS_URL } from '../../../constants';
import classes from './Layout.module.scss';

const Layout = (props) => {
    const { children } = props;

    const childrenWithExtraProp = React.Children.map(children, child =>
        React.cloneElement(child)
    );

    return (
        <main 
            className={classes.Layout}
            style={{ backgroundImage: `url(${bgPattern1}), url(${bgPattern2})` }}
        >
            <div className={classes.Layout_Content}>
                <div className={`container ${classes.Layout_Container}`}>
                    {childrenWithExtraProp}

                    <div className={classes.SecurityLogoWrap}>
                        <p className={classes.SecurityText}> <MdSecurity size="1rem" /> Secured By</p>
                        <img src={SecurityLogo} className={classes.SecurityLogo} alt="safe & secured" />
                        <p className={classes.PageFooter}>
                            <a  
                                className={classes.PageFooter__Link} 
                                href={PG_TERMS_AND_CONDITIONS_URL} 
                                target="_blank" 
                            >
                                Terms & Conditions
                            </a> 
                            <a 
                                className={classes.PageFooter__Link} 
                                href={PG_PRIVACY_POLICY_URL} 
                                target="_blank" 
                            >
                                Privacy Policy
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </main>
    )
}

Layout.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
};

export default Layout;